<template>
  <div v-if="show" class="sidebar-links">
    <router-link to="/hospitals">All Hospitals</router-link>
    <rp-permissions :requireAll="['write_hospitals']">
      <router-link to="/hospitals/add-hospital">Add Hospital</router-link>
    </rp-permissions>

  </div>
</template>

<script>
import Permissions from 'raypro_ui/src/components/Permissions'

export default {

  components: {'rp-permissions': Permissions},

  computed: {
    path() {
      return this.$route.path
    },

    show() {
      return new RegExp('/hospitals').test(this.path)
    }
  }
}
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/SideNav/HospitalsLinks.vue